
import { FETCH_BREEDS, CREATE_BREED, UPDATE_BREED, DELETE_BREEDS, FETCH_ANIMALS, FETCH_BREEDS_BY_ANIMAL , FETCH_BREED_INFO, FETCH_BREEDER_INFO , FETCH_UPDATED_BREED_BY_ID,
       } from '../actions';


const initialState = {
  deleteBreedType: null,
  updateBreedType: null,
  setBreedType: null,
  selectedToDelete: null,
  selectedToEdit: null,
  updatedBreedTypeById : null,
  breedTypes: [],
  animalTypes: [],
  loading: false,
  breedsByAnimal: [],
  breedInfo : {},
  deleteBreedTypeError:null,
  updateBreedTypeError:null,
  setBreedTypeError:null,
  breedTypesError:null,
  animalTypesError:null,
  breedsByAnimalError:null,
  breedInfoError : null,
  updatedBreedTypeByIdError : null, 
};


function addBreedTypeReducer(state = initialState, action) {
  let breedTypes,
    animalTypes,
    setBreedType,
    updateBreedType,
    deleteBreedType,
    breedInfo,
    updatedBreedTypeById,
    breedsByAnimal;

  switch (action.type) {
    case `${DELETE_BREEDS}_PENDING`:
    case `${CREATE_BREED}_PENDING`:
    case `${UPDATE_BREED}_PENDING`:
    case `${FETCH_BREEDS}_PENDING`:
    case `${FETCH_ANIMALS}_PENDING`:
    case `${FETCH_BREED_INFO}_PENDING` : 
    case `${FETCH_UPDATED_BREED_BY_ID}_PENDING` : 
    case `${FETCH_BREEDS_BY_ANIMAL}_PENDING`:
 
      return { ...state, loading: true,
        deleteBreedType: null,
        deleteBreedTypeError:null,
        updateBreedTypeError:null,
        setBreedTypeError:null,
        breedTypesError:null,
        animalTypesError:null,
        breedsByAnimalError:null,
        updatedBreedTypeByIdError:null,       
      };  

    case `${CREATE_BREED}_FULFILLED`:
      setBreedType = action.payload.data;
      return { ...state, loading: false, setBreedType };

    case `${UPDATE_BREED}_FULFILLED`:
      updateBreedType = action.payload.data;
      return { ...state, loading: false, updateBreedType };

    case `${DELETE_BREEDS}_FULFILLED`:
      deleteBreedType = action.payload.data;
      return { ...state, loading: false, deleteBreedType };

    case `${FETCH_BREEDS}_FULFILLED`:
      breedTypes = action.payload.data;
      return { ...state, loading: false, breedTypes };

    case `${FETCH_ANIMALS}_FULFILLED`:
      animalTypes = action.payload.data;
      return { ...state, loading: false, animalTypes };

    case `${FETCH_BREED_INFO}_FULFILLED` :
      breedInfo  = action.payload.data;
      return { ...state, loading: false, breedInfo };

    case `${FETCH_BREEDS_BY_ANIMAL}_FULFILLED`:
      breedsByAnimal = action.payload.data;
      return { ...state, loading: false, breedsByAnimal };

    case `${FETCH_UPDATED_BREED_BY_ID}_FULFILLED`:
      updatedBreedTypeById = action.payload.data;
      return { ...state, loading: false, updatedBreedTypeById };     

    case `${DELETE_BREEDS}_REJECTED`:
      return {
        ...state, loading: false, deleteBreedTypeError: action.payload.response.data, state: initialState,
      };
    case `${UPDATE_BREED}_REJECTED`:
      return {
        ...state, loading: false, updateBreedTypeError: action.payload.response.data, state: initialState,
      };
    case `${CREATE_BREED}_REJECTED`:
      return {
        ...state, loading: false, setBreedTypeError: action.payload.response.data, state: initialState,
      };
    case `${FETCH_BREEDS}_REJECTED`:
      return {
        ...state, loading: false, breedTypesError: action.payload.response.data, state: initialState,
      };
    case `${FETCH_ANIMALS}_REJECTED`:
      return {
        ...state, loading: false, animalTypesError: action.payload.response.data, state: initialState,
      };
      case `${FETCH_BREEDER_INFO}_REJECTED`:
        return {
          ...state, loading: false, breedInfoError: action.payload.response.data, state: initialState,
        }; 
    case `${FETCH_BREEDS_BY_ANIMAL}_REJECTED`:
      return {
        ...state, loading: false, breedsByAnimalError: action.payload.response.data, state: initialState,
      };
    case `${FETCH_UPDATED_BREED_BY_ID}_REJECTED`:
      return {
        ...state, loading: false, updatedBreedTypeByIdError: action.payload.response.data, state: initialState,
      };

    default:
      return state;
  }
}

export default addBreedTypeReducer;
